module.exports = __webpack_public_path__ + "img/3.1707f6fb.jpg";